import { render, staticRenderFns } from "./DoubleTabItems.vue?vue&type=template&id=734b1218&scoped=true&"
import script from "./DoubleTabItems.vue?vue&type=script&lang=ts&"
export * from "./DoubleTabItems.vue?vue&type=script&lang=ts&"
import style0 from "./DoubleTabItems.vue?vue&type=style&index=0&id=734b1218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734b1218",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VExpandTransition,VIcon})
